import KBaseMapDialog from "../Maps/KBaseMapDialog";
import { KAddressMap, KLink } from ".";
import { formatLocation } from "kinnect-formatters";

export default KBaseMapDialog.extend( {
	name: "KAddressMapDialog",

	props: {
		activatorIcon: {
			default: "place",
			type: String
		},

		address: {
			required: true,
			type: Object,
			validator: value =>
				typeof value.lat === "number"
					&& typeof value.lng === "number"
					&& typeof value.address === "string"
					&& typeof value.city === "string"
		}
	},

	computed: {
		formattedAddress() {
			return formatLocation( this.address, "a, c" );
		},

		internalTitle() {
			if ( this.title ) {
				return this.title;
			}

			return this.formattedAddress;
		}
	},

	render() {
		return <KBaseMapDialog
			attrs={{
				...this.$props,
				title: this.internalTitle
			}}
			on={this.$listeners}
			scopedSlots={{
				activator: ( { on } ) =>
					<KLink
						icon={this.activatorIcon}
						on={on}
					>
						{formatLocation( this.address, "a, c" )}
					</KLink>,

				...this.$scopedSlots
			}}
		>
			{this.genActivator()}

			<KAddressMap
				lat={this.address.lat}
				lng={this.address.lng}
			></KAddressMap>
		</KBaseMapDialog>;
	}
} );
